export const _getYearOptions = () => {
  const startYear = 2015;
  const currentYear = new Date().getFullYear();
  const years = [];

  for (let year = currentYear; year >= startYear; year--) {
    years.push(year.toString());
  }
  return years;
};

export const _toDate = (dateValue, setHoursToZero = false) => {
  const date = new Date(dateValue);
  if (setHoursToZero) {
    date.setHours(0, 0, 0, 0);
  }
  return date;
};

export const _toISOString = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const _timeDiffToDays = (timeDiff, inclusive = false) => {
  const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  return inclusive ? days + 1 : days;
};

export const _parseDateRangeToUTC = (dateRange, addDaysToEnd = false) => {
  if (!dateRange?.startDate || !dateRange?.endDate) return null;
  
  const toUTCMidnight = (dateInput) => {
    const d = new Date(dateInput);
    return isNaN(d.getTime()) ? null : new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  };
  
  const start = toUTCMidnight(dateRange.startDate);
  const end = toUTCMidnight(dateRange.endDate);
  if (!start || !end) return null;
  
  const finalEnd = new Date(end);
  const daysToAdd = addDaysToEnd ? 2 : 1;
  finalEnd.setUTCDate(finalEnd.getUTCDate() + daysToAdd);
  
  return {
    startDate: start.toISOString(),
    endDate: finalEnd.toISOString()
  };
};

export const _parseDateRangeToISOString = (datePicked) => {
  if (!datePicked?.startDate || !datePicked?.endDate) return [];
  
  const startDate = _toDate(datePicked.startDate, true);
  const endDate = _toDate(datePicked.endDate, true);

  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return [];

  const dateStrings = [];

  while (startDate <= endDate) {
    dateStrings.push(_toISOString(startDate));
    startDate.setDate(startDate.getDate() + 1);
  }
  
  return dateStrings;
};

export const _getDayName = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", { weekday: "long" });
};

export const _toMinutes = (timeStr, isTimeOut = false) => {
  if (!timeStr || timeStr === "--:--") {
    return 0;
  }

  const [hour, minute] = timeStr.split(":").map(Number);
  let total = hour * 60 + minute;

  if (!isTimeOut && total < 60) {
    return total + 1440;
  }

  return total;
};


export const _createUTCDate = (dateObj, dayOffset = 0, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) => {
  return new Date(Date.UTC(
    dateObj.getFullYear(),
    dateObj.getMonth(),
    dateObj.getDate() + dayOffset,
    hours,
    minutes,
    seconds,
    milliseconds
  ));
};

export const _parseDateRange = (range) => {
  const startDate = range?.startDate;
  const endDate = range?.endDate;
  
  if (!startDate || !endDate) return null;
  
  const startDateObj = new Date(startDate);
  const endDateObj = new Date(endDate);
  
  if (isNaN(startDateObj.getTime()) || isNaN(endDateObj.getTime())) return null;
  
  const startOfRange = _createUTCDate(startDateObj, 0, 0, 0, 0, 0);
  const endOfRange = _createUTCDate(endDateObj, 1, 23, 59, 59, 999);
  
  return {
    startDate: startOfRange.toISOString(),
    endDate: endOfRange.toISOString(),
  };
};

export const  parseDateRangeToQuery = (range) => {
  const parsed = _parseDateRange(range);
  if (!parsed) return null;
  
  const startDate = parsed.startDate.split('T')[0];
  const endDate = parsed.endDate.split('T')[0];

  const endDateObj = new Date(range.endDate);
  const taggingEndDate = isNaN(endDateObj.getTime())
    ? endDate
    : _createUTCDate(endDateObj, 0, 0, 0, 0, 0).toISOString().split('T')[0];
  
  const dateRangeQuery = {
      $gte: startDate,
      $lte: endDate
  };

  const taggingDateRangeQuery = {
      $gte: startDate,
      $lte: taggingEndDate
  };
  
  return {
    parsed,
    dateRangeQuery,
    taggingDateRangeQuery,
  };
}
